export default __webpack_public_path__ + "0c8f6e9e0cb9e8a66cb9f18a9ed4f1e0.png";